/**
 * Normalize Laravel / mixed API list payloads into a plain array.
 *
 * @param {unknown} payload
 * @returns {Array<Record<string, unknown>>}
 */
export function normalizeCollectionResponse(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  if (Array.isArray(payload?.modules)) {
    return payload.modules;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  if (Array.isArray(payload?.data?.items)) {
    return payload.data.items;
  }

  return [];
}

/**
 * Normalize a single-resource API payload.
 *
 * @param {unknown} payload
 * @returns {Record<string, unknown>|null}
 */
export function normalizeObjectResponse(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null;
  }

  if (payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) {
    return payload.data;
  }

  return payload;
}
